import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SegmentCategory = {
	name: NAME,
	apiProvider,
	router,
};
